import axios from 'axios'

export type LoginError = {
  message: string
}

export type LoginResponse = {
  expiresAt: string
  id: string
  userId: string
  updatedAt: string
  createdAt: string
}

export type LoginTokenResponse = {
  accessToken: string
  refreshToken?: string
}

export const loginUser = (email: string, password: string) =>
  axios.post<LoginResponse | LoginError>('/sessions', { email, password })

export const loginToken = (email: string, password: string) =>
  axios.post<LoginTokenResponse | LoginError>('/users/login', { email, password })

export const refreshToken = (token: string) => axios.post<LoginTokenResponse | LoginError>('/users/token', { token })

export const logoutUser = (refresh: string) => axios.delete(`/users/logout/${refresh}`)
